// ****************** AUTH0 ******************

// A function that routes the user to the right place
// after login
const onRedirectCallback = (history) => (appState) => {
  history.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
}

// Workaround for gitlab.io, which needs path
const redirectUri = () => {
  const base = window.location.origin
  if (base === 'https://venture-analytics.gitlab.io') return `${base}/ventury-app`
  return base
}

const getAuth0config = (history) => ({
  domain: 'eqvanta.eu.auth0.com',
  client_id: '8ZGyyyNMBAYbs2vPQrShiSztBFQzZrgT',
  redirect_uri: redirectUri(),
  audience: 'https://app.eqvanta.de', // on prod and staging, the backend is mapped on /api
  onRedirectCallback: onRedirectCallback(history),
})

export { redirectUri }
export default getAuth0config
